import React, { useEffect, useState } from "react";
import {
  DateInput,
  Filter,
  SelectArrayInput,
  useDataProvider,
} from "react-admin";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  selectArrayInput: {
    minWidth: "205px",
    margin: "0",
  },
}));

const MediaObjectListFilters = (props) => {
  const dataProvider = useDataProvider();
  const classes = useStyles();
  const [interventionSubjects, setInterventionSubjects] = useState([]);
  const [logBookTypes, setLogBookTypes] = useState([]);

  useEffect(() => {
    const initializeOptions = async () => {
      const {
        data: interventionSubjectsOptions,
      } = await dataProvider.getResource("intervention_subjects");
      setInterventionSubjects(interventionSubjectsOptions);
      const { data: logBookTypes } = await dataProvider.getResource(
        "log_book_types"
      );
      setLogBookTypes(logBookTypes);
    };
    initializeOptions();
  }, [dataProvider, setLogBookTypes]);

  if (!navigator.onLine) {
    return null;
  }

  return (
    <Filter {...props}>
      <SelectArrayInput
        source="logBookEntryVersions.interventionSubject"
        label="Objets de l'intervention"
        className={classes.selectArrayInput}
        choices={interventionSubjects}
      />
      <SelectArrayInput
        source="logBookEntryVersions.logBookEntry.logBookType"
        label="Mains courantes"
        className={classes.selectArrayInput}
        choices={logBookTypes}
      />
      <DateInput
        source="logBookEntryVersions.interventionStartDate.after"
        label="Date de début"
      />
      <DateInput
        source="logBookEntryVersions.interventionStartDate.before"
        label="Date de fin"
      />
    </Filter>
  );
};

export default MediaObjectListFilters;
